import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/arrow-right-icon.svg'


const _hoisted_1 = { class: "home-view" }
const _hoisted_2 = { class: "home-view__title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatBotLinks = _resolveComponent("ChatBotLinks")!
  const _component_MessengerDownloadLinks = _resolveComponent("MessengerDownloadLinks")!
  const _component_MobileAppsLinks = _resolveComponent("MobileAppsLinks")!
  const _component_AppLinkButton = _resolveComponent("AppLinkButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createElementVNode("div", { innerHTML: _ctx.homeViewTitle }, null, 8, _hoisted_3)
    ]),
    _createVNode(_component_ChatBotLinks),
    (_ctx.showDownloadLinks === 'true')
      ? (_openBlock(), _createBlock(_component_MessengerDownloadLinks, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showMobileLinks === 'true')
      ? (_openBlock(), _createBlock(_component_MobileAppsLinks, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.showPayLink === 'true')
      ? (_openBlock(), _createBlock(_component_AppLinkButton, {
          key: 2,
          onClick: _ctx.toPayService
        }, {
          append: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createTextVNode("Оплатить заказ ")
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}